/* eslint-disable @typescript-eslint/naming-convention */
import { ScheduledEventEmailsVM } from '../components/_events/_manage-event/_edit-website/website-form-body/scheduled-emails-form/_scheduled-events-emails-form.viewmodel';
import { ScheduledMeetingsEmailsVM } from '../components/_events/_manage-event/_edit-website/website-form-body/scheduled-emails-form/_scheduled-meeting-emails-form.viewmodel';
import { AttendeeRole } from './attendees.dao';
import { IEventRequestParams } from './shared.dto';

abstract class IScheduledEmailDAO {
    public abstract getScheduledEmails(params: IEventRequestParams): Promise<IScheduledEmailsListDTO>;
    public abstract createScheduledEmail(params: ICreateScheduledEmailRequestParams): Promise<IScheduledEmailDTO>;
    public abstract updateScheduledEmail(params: IScheduledEmailRequestParams): Promise<IScheduledEmailDTO>;
    public abstract deleteScheduledEmail(params: IDeleteScheduledEmailRequestParams): Promise<void>;
    public abstract sendPreviewScheduledEmail(params: IPreviewScheduledEmailRequestParams): Promise<void>;
}

type IScheduledEmailsListDTO = IScheduledEmailDTO[];

enum ScheduledEmailStatus {
    SCHEDULED = 'SCHEDULED',
    SUCCEEDED = 'SUCCEEDED',
    IN_PROGRESS = 'IN_PROGRESS',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
}

enum MessageStatus {
    SCHEDULED = 'SCHEDULED',
    SENT = 'SENT',
    SENDING = 'SENDING',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED'
}

const EMAIL_TO_MESSAGE_STATUS_MAPPER = {
    [ScheduledEmailStatus.SCHEDULED]: MessageStatus.SCHEDULED,
    [ScheduledEmailStatus.SUCCEEDED]: MessageStatus.SENT,
    [ScheduledEmailStatus.IN_PROGRESS]: MessageStatus.SENDING,
    [ScheduledEmailStatus.FAILED]: MessageStatus.FAILED,
    [ScheduledEmailStatus.CANCELLED]: MessageStatus.CANCELLED,
};

interface IMessagesStats {
    failedNumber: number;
    recipientNumber: number;
    sentMessagesNumber: number;
}

interface IScheduledEmailDTO extends ICreateScheduleEmailDTO {
    id: string;
    status: ScheduledEmailStatus;
    meetingId?: number;
    roles?: AttendeeRole[];
    messagesStats?: IMessagesStats;
}

interface IScheduledEmailTemplateDTO {
    id?: string;
    subject: string;
    body: string;
    emailImage?: {
        objectKey: string;
        title: string;
    };
    emailImageWithUrl?: {
        assetUrl: string;
        title: string;
    };
}

type IUpdateScheduleEmailDTO = Omit<IScheduledEmailDTO, 'status'>;

interface ICreateScheduleEmailDTO {
    name: string;
    dateTime: Date;
    emailTemplate?: IScheduledEmailTemplateDTO;
    notifyDeliveryTeam?: boolean;
}

interface IDeleteScheduledEmailRequestParams extends IEventRequestParams {
    id: string;
    type: ScheduledTypes;
}

interface IPreviewScheduledEmailRequestParams extends IEventRequestParams {
    id: string;
    meetingId: number | undefined;
}

type ICreateScheduledEmailRequestParams = ICreateScheduleEmailDTO & IEventRequestParams;
type IScheduledEmailRequestParams = IUpdateScheduleEmailDTO & IEventRequestParams;

interface ITrackingEmailValues {
    'Account Name': string;
    'Account ID': number;
    'Event Name': string;
    'Event ID': number;
    'Date & Time of the email': string;
    'Email Type': string;
    'Meeting ID'?: number | string;
    'Roles'?: string;
}

enum ScheduledTypes {
    Event = 'event',
    Meeting = 'meeting'
}

enum ScheduledEmailSentStatus {
    Sent = 'Sent',
    Other = 'Other'
}

enum ScheduledEmailSentStatusLabel {
    Sent = 'Sent',
    Scheduled = 'Scheduled'
}

type EmailGroupItem = {
    type: ScheduledTypes;
    status: ScheduledEmailSentStatus;
    emails: IScheduledEmailDTO[];
    viewModel: ScheduledEventEmailsVM | ScheduledMeetingsEmailsVM;
};

export {
    IScheduledEmailDAO,
    IScheduledEmailsListDTO,
    IScheduledEmailDTO,
    ICreateScheduleEmailDTO,
    IUpdateScheduleEmailDTO,
    IDeleteScheduledEmailRequestParams,
    ICreateScheduledEmailRequestParams,
    IScheduledEmailRequestParams,
    ScheduledEmailStatus,
    IScheduledEmailTemplateDTO,
    MessageStatus,
    EMAIL_TO_MESSAGE_STATUS_MAPPER,
    ITrackingEmailValues,
    ScheduledTypes,
    IPreviewScheduledEmailRequestParams,
    ScheduledEmailSentStatus,
    ScheduledEmailSentStatusLabel,
    EmailGroupItem,
};
